/**
 * Actualisation centralisée du cache après un changement de stock / cuvée / domaine.
 * Invalide en une fois toutes les vues dépendantes (La cave, fiches, carte, tableaux de bord)
 * pour garantir des données à jour quand l'utilisateur — ou un autre — modifie quelque chose.
 * React Query fait une correspondance partielle : ['domain'] invalide tous les ['domain', id].
 */
export function invalidateStock(qc) {
  ['stock', 'cuvee', 'domains', 'domain', 'alerts', 'dashboard-stats',
   'dashboard-movements', 'degustes', 'achats-summary'].forEach((k) =>
    qc.invalidateQueries({ queryKey: [k] }));
}
